import request from '@/utils/request'

// 查询列表
export function apiScpMrpExceptionsPlanExceptionsList (data) {
  return request({
    url: '/scp/scpMrpExceptions/planExceptionsList',
    method: 'post',
    data: data
  })
}

// 物料类别
export function apiScpMrpCategoryCodeCategoryBox (query) {
  return request({
    url: '/scp/scpMrpCategoryCode/categoryBox',
    method: 'get',
    params: query
  })
}

// 数据收集时间、叫料计算完成时间
export function apiScpMrpPlansCallMaterialPlanExecutionTime (query) {
  return request({
    url: '/scp/scpMrpPlans/callMaterialPlanExecutionTime',
    method: 'get',
    params: query
  })
}
